import { post, get, put, deleteApi } from '../axiosFun';

// 数量总揽
export const overviewCount = () => { return get("/train/overview/overviewCount") };
export const planStatisticPage = (params) => { return post("/train/overview/planStatisticPage",params) };


// WEBPACK FOOTER //
// ./src/api/onlineTraining/overview.js